import { render, staticRenderFns } from "./agent-view.vue?vue&type=template&id=39737656&scoped=true&"
import script from "./agent-view.vue?vue&type=script&lang=js&"
export * from "./agent-view.vue?vue&type=script&lang=js&"
import style0 from "./agent-view.vue?vue&type=style&index=0&id=39737656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39737656",
  null
  
)

export default component.exports